export const TEXT_FORMATTING_TAGS_BEYOND_DEFAULT_SCHEMA = ["u", "small", "mark", "abbr", "cite", "font", "center"] as const

export const TEXT_FORMATTING_TAG_ATTRIBUTES = { abbr: ["title"] }

export const SECTIONING_TAGS_BEYOND_DEFAULT_SCHEMA = [
  "header",
  "footer",
  "main",
  "nav",
  "article",
  "aside",
  "figure",
  "figcaption",
  "address",
] as const

export const DOCUMENT_SCAFFOLDING_TAGS = ["html", "head", "body", "meta", "link"] as const

export const RAW_TEXT_TAGS_STRIPPED_WITH_CONTENT = ["script", "style", "title"] as const

export const CITATION_ANCHOR_ATTRIBUTES = [
  "bookmark_start",
  "bookmarkStart",
  "bookmark_end",
  "bookmarkEnd",
  "data-cite-block-start",
  "data-cite-block-end",
  "data-cite-document-title",
] as const
